export default {"src":"/_next/static/media/instagram.a0d33181.svg","height":2500,"width":2500};